/**
 * Constants for ChatInput component
 */
import type { editor } from "monaco-editor";

/** Custom language ID for the chat input editor */
export const CUSTOM_LANGUAGE_ID = "chat-input";

/** Monaco theme names for light and dark modes */
export const MONACO_THEMES = {
  light: "transparent-light",
  dark: "transparent-dark",
} as const;

/**
 * Theme definitions for Monaco editor with transparent backgrounds.
 * defineTheme `colors` only accepts hex strings — CSS var() is not supported.
 * Widget chrome colors that need MUI palette reactivity are overridden via
 * CSS custom properties (--vscode-*) in ChatInput.css instead.
 */
export const THEME_DEFINITIONS: Record<
  "light" | "dark",
  editor.IStandaloneThemeData
> = {
  light: {
    base: "vs",
    inherit: false,
    rules: [],
    colors: {
      "editor.foreground": "#292929",
      "editor.background": "#00000000",
      "editorSuggestWidget.background": "#FFFFFF",
      "editorSuggestWidget.foreground": "#000000",
      "editorSuggestWidget.border": "#E0E0E0",
      // "editorSuggestWidget.selectedBackground": "#E8E8E8",
    },
  },
  dark: {
    base: "vs-dark",
    inherit: false,
    rules: [],
    colors: {
      "editor.foreground": "#fcfcfc",
      "editor.background": "#00000000",
      "editorSuggestWidget.background": "#000000",
      "editorSuggestWidget.foreground": "#FFFFFF",
      "editorSuggestWidget.border": "#333333",
      // "editorSuggestWidget.selectedBackground": "#2A2A2A",
    },
  },
};

/** Character that triggers skill suggestions */
export const SKILL_TRIGGER_CHAR = "/";

/** Character that triggers entity mention suggestions */
export const ENTITY_TRIGGER_CHAR = "@";

/** CSS class name for highlighting skills in the editor */
export const SKILL_HIGHLIGHT_CLASS = "skill-highlight";

/** CSS class name for highlighting entity mentions in the editor */
export const ENTITY_HIGHLIGHT_CLASS = "entity-mention-highlight";

/** State value indicating that Monaco's suggest controller is active (showing suggestions) */
export const SUGGEST_CONTROLLER_ACTIVE_STATE = 2;
